<dsd-container
  *ngIf="infoCarte"
  margin="none"
  padding="md"
  border-radius="sm"
  class="info-carte dsd-br-md dsd-mb-0"
  background-color="dsd-color-background-decorative-graphite-100">
  <div class="dsd-d-flex dsd-ai-baseline">
    <img
      class="dsd-pr-xs"
      *ngIf="infoCarte?.numeroCarte[0] === '4' || infoCarte?.reseau === 'Visa'"
      height="10"
      src="https://static.desjardins.com/fw/dsd/assets/1.29.0/logos/visa.svg"
      alt="Visa"
      aria-hidden="true" />
    <img
      class="dsd-pr-xs"
      *ngIf="infoCarte?.numeroCarte[0] === '5' || infoCarte?.reseau === 'Mastercard'"
      height="10"
      src="https://static.desjardins.com/fw/dsd/assets/1.29.0/logos/mastercard.svg"
      alt="MasterCard"
      aria-hidden="true" />
    <p class="dsd-m-0">
      <span class="dsd-fw-bold dsd-mb-0">{{ infoCarte.descriptionCourte | titlecase }}</span>
      <span class="dsd-sr-only"
        >{{ 'caad.accueil.libelle.horsEcran.carteCreditTerminant' | translate }}
        {{ infoCarte?.numeroCarte.substring(12, 16) }}</span
      >
      <br />
      <span class="dsd-m-0" aria-hidden="true">{{ infoCarte?.numeroCarte | masquerCarte }}</span>
    </p>
  </div>
</dsd-container>
